'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _reactImageGallery = require('react-image-gallery');
var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultBackgroundColor = '#d3d3d3';
var styles = {
  CarouselPaginator: {
    padding: '1rem',
    '& .image-gallery ': {
      '& .image-gallery-content': {
        '& .image-gallery-slide-wrapper .image-gallery-bullets': {
          bottom: '-2.5rem',
          '& .image-gallery-bullets-container': {
            '& button': {
              borderStyle: 'solid',
              borderColor: function borderColor(_ref) {
                var backgroundColor = _ref.sharedProperties.backgroundColor;
                return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.2);
              },
              backgroundColor: function backgroundColor(_ref2) {
                var _backgroundColor = _ref2.sharedProperties.backgroundColor;
                return (0, _colorManipulator.lighten)(_backgroundColor || defaultBackgroundColor, 0.4);
              },
              boxShadow: 'none'
            },
            '& .active': {
              borderStyle: 'solid',
              borderColor: function borderColor(_ref3) {
                var backgroundColor = _ref3.sharedProperties.backgroundColor;
                return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.4);
              },
              backgroundColor: function backgroundColor(_ref4) {
                var _backgroundColor2 = _ref4.sharedProperties.backgroundColor;
                return (0, _colorManipulator.darken)(_backgroundColor2 || defaultBackgroundColor, 0.4);
              }
            }
          }
        },
        '& .image-gallery-swipe .image-gallery-slides': {
          '& .image-gallery-slide center': {
            backgroundColor: function backgroundColor(_ref5) {
              var _backgroundColor3 = _ref5.sharedProperties.backgroundColor;
              return _backgroundColor3 || defaultBackgroundColor;
            }
          }
        }
      }
    }
  },
  slide: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: function backgroundColor(_ref6) {
      var _backgroundColor4 = _ref6.sharedProperties.backgroundColor;
      return _backgroundColor4 || defaultBackgroundColor;
    }
  },
  leftNav: {
    height: '1rem',
    width: '1rem',
    borderStyle: 'solid',
    borderColor: function borderColor(_ref7) {
      var backgroundColor = _ref7.sharedProperties.backgroundColor;
      return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.6);
    },
    borderWidth: '0 3px 3px 0',
    display: 'inline-block',
    padding: '3px',
    transform: 'rotate(135deg) translateY(-50%)',
    left: '0',
    top: '50%',
    position: 'absolute',
    zIndex: '4',
    outline: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer'
  },
  rightNav: {
    height: '1rem',
    width: '1rem',
    borderStyle: 'solid',
    borderColor: function borderColor(_ref8) {
      var backgroundColor = _ref8.sharedProperties.backgroundColor;
      return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.6);
    },
    borderWidth: '0 3px 3px 0',
    display: 'inline-block',
    padding: '3px',
    transform: 'rotate(-45deg) translateY(-50%)',
    right: '0',
    top: '50%',
    position: 'absolute',
    zIndex: '4',
    outline: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer'
  },
  playStopButton: {
    left: '0',
    bottom: '-4rem',
    backgroundColor: 'transparent',
    border: '0',
    cursor: 'pointer',
    outline: 'none',
    position: 'absolute',
    zIndex: '4',
    height: '0',
    width: '0',
    borderTop: '14px solid transparent',
    borderBottom: '14px solid transparent',
    borderLeftStyle: 'solid',
    borderLeftColor: function borderLeftColor(_ref9) {
      var backgroundColor = _ref9.sharedProperties.backgroundColor;
      return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.6);
    },
    borderLeftWidth: '20px',
    '&.active': {
      borderLeft: '8px solid #555',
      borderLeftStyle: 'solid',
      borderLeftColor: function borderLeftColor(_ref10) {
        var backgroundColor = _ref10.sharedProperties.backgroundColor;
        return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.6);
      },
      borderLeftWidth: '8px',
      borderRightStyle: 'solid',
      borderRightColor: function borderRightColor(_ref11) {
        var backgroundColor = _ref11.sharedProperties.backgroundColor;
        return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.6);
      },
      borderRightWidth: '8px',
      borderTop: '0px solid transparent',
      borderBottom: '0px solid transparent',
      minWidth: '1px',
      minHeight: '20px',
      backgroundColor: 'transparent',
      padding: '3px'
    }
  }
};
var CarouselPaginator = function (_Component) {
  _inherits(CarouselPaginator, _Component);
  function CarouselPaginator() {
    var _ref12;
    var _temp, _this, _ret;
    _classCallCheck(this, CarouselPaginator);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref12 = CarouselPaginator.__proto__ || Object.getPrototypeOf(CarouselPaginator)).call.apply(_ref12, [this].concat(args))), _this), _this.renderSlide = function (groupOfItems) {
      var _this$props = _this.props,
        classes = _this$props.classes,
        renderSingleItem = _this$props.renderSingleItem;
      return _react2.default.createElement('div', {
        className: classes.slide
      }, groupOfItems.map(renderSingleItem));
    }, _this.renderLeftNav = function (onClick, disabled) {
      var classes = _this.props.classes;
      return _react2.default.createElement('button', {
        className: classes.leftNav,
        disabled: disabled,
        onClick: onClick
      });
    }, _this.renderRightNav = function (onClick, disabled) {
      var classes = _this.props.classes;
      return _react2.default.createElement('button', {
        className: classes.rightNav,
        disabled: disabled,
        onClick: onClick
      });
    }, _this.renderPlayPauseButton = function (onClick, isPlaying) {
      var classes = _this.props.classes;
      return _react2.default.createElement('button', {
        type: 'button',
        className: '' + classes.playStopButton + (isPlaying ? ' active' : ''),
        onClick: onClick
      });
    }, _this.partitionItems = function () {
      var _this$props2 = _this.props,
        items = _this$props2.items,
        perGroup = _this$props2.perGroup;
      var result = [];
      for (var i = 0; i < items.length; i += perGroup) {
        result.push(items.slice(i, i + perGroup));
      }
      return result;
    }, _this.fetchNextIfNeeded = function (currentGroupIndex) {
      var _this$props3 = _this.props,
        items = _this$props3.items,
        perGroup = _this$props3.perGroup,
        next = _this$props3.next,
        fetchPage = _this$props3.fetchPage;
      var reachedLastPage = currentGroupIndex + 1 === Math.ceil(items.length / perGroup);
      if (reachedLastPage && !!next) {
        fetchPage(next);
      }
    }, _this.onSlide = function (currentGroupIndex) {
      _this.fetchNextIfNeeded(currentGroupIndex);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(CarouselPaginator, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchNextIfNeeded(0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        sharedProperties = _props.sharedProperties;
      return _react2.default.createElement('div', {
        className: classes.CarouselPaginator
      }, _react2.default.createElement(_reactImageGallery2.default, {
        items: this.partitionItems(),
        showThumbnails: false,
        showBullets: true,
        bulletClass: classes.bullets,
        renderItem: this.renderSlide,
        renderLeftNav: this.renderLeftNav,
        renderRightNav: this.renderRightNav,
        renderPlayPauseButton: this.renderPlayPauseButton,
        onSlide: this.onSlide,
        lazyLoad: true,
        autoPlay: true,
        showFullscreenButton: false,
        slideInterval: 5000
      }));
    }
  }]);
  return CarouselPaginator;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(CarouselPaginator);